var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-dialog', _vm._g(_vm._b({ attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }, "close": _vm.handleClose } }, 'el-dialog', _vm.dialogAttrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };